import Vue from 'vue'
import {
  getCurrentClinic,
  getCurrentUser
} from '../../utils/localStorageManager'

const setChannel = async (context, payload) => {
  context.commit('setChannel', payload)
}

const setUserChannel = async (context, payload) => {
  context.commit('setUserChannel', payload)
}

const unsubscribe = async context => {
  const clinic = getCurrentClinic()
  const tabId = window.sessionStorage.getItem('tabId')

  Vue.prototype.pusher.unsubscribe(`clinic-${clinic.id}-tab-${tabId}`)
  // Vue.prototype.pusher.unsubscribe(`clinic-${clinic.id}`)
  context.commit('setChannel', null)

  // O canal do usuário (export de relatório, impl-07 §4) sai junto: deixá-lo
  // assinado na troca de clínica manteria uma subscrição órfã por aba.
  const user = getCurrentUser()
  if (user?.id) {
    Vue.prototype.pusher.unsubscribe(`user-${user.id}-tab-${tabId}`)
  }
  context.commit('setUserChannel', null)
}

export default {
  setChannel,
  setUserChannel,
  unsubscribe
}
